import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import {OEStdCapBarTargetTypeFlags} from '../../bars/cap/std/oe-std-cap-bar-model';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEMediCADemyTargetType, OEMediCADemyTargets, OEMediCADemyFeatureAccess, OEMediCADemyStartSelectionData} from './oe-medicademy-model';

export default class OEMediCADemyCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        const flags = OEStdCapBarTargetTypeFlags.default | OEStdCapBarTargetTypeFlags.noTooltip;

        this.targetTypeMap = {
            [OEMediCADemyTargetType.implantcast]:   {icon: OEIconCodes.mediCADemy.implantcastTarget, labelId: 'cap_bar_target_title_implantcast', titleId: 'cap_bar_target_title_implantcast', flags: flags},
            [OEMediCADemyTargetType.ido]:           {icon: OEIconCodes.mediCADemy.idoTarget, labelId: 'cap_bar_target_title_ido', titleId: 'cap_bar_target_title_ido', flags: flags},
            [OEMediCADemyTargetType.ohst]:          {icon: OEIconCodes.mediCADemy.ohstTarget, labelId: 'cap_bar_target_title_ohst', titleId: 'cap_bar_target_title_ohst', flags: flags},
            [OETarget.effigosExplorerHelp]:         {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = OEMediCADemyStartSelectionData.chooseModules().map(module => module.id);
        targetTypes.push(OETarget.effigosExplorerHelp);

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEMediCADemyTargets}
                featureAccess={OEMediCADemyFeatureAccess}
                startSelectionData={OEMediCADemyStartSelectionData}
            />
        );
    }
}